<div class="col-lg-12">
  <div class="card">
    <div class="card-body">

      <button type="button" id="btnAllocate" (click)="allocateVendorConfirmation()" style="display:none">Add</button>
      <button type="button" id="btnSendtoVendor" (click)="sendtoVendorConfirmation()" style="display:none">Add</button>


      <button type="button" id="btnMultipleAllocate" (click)="allocateSelecteArticle()" style="display:none">Add</button>
      <button type="button" id="btnAllocateConfirm" (click)="allocateVendor()" style="display:none">Add</button>
      <button type="button" id="btnDropChange" (click)="dropdownlist()" style="display:none">Drop</button>
      <button type="button" id="btnDropChangeAll" (click)="dropdownlistValue()" style="display:none">Drop</button>
      <button type="button" id="btnGetBatch" (click)="getArticleByBatch()" style="display:none">GetVolumeIssue</button>

      <button type="button" id="btnSendtoVendorConfirm" (click)="sendtoVendor()" style="display:none">Drop</button>

      <button type="button" id="btnMultipleSendtoVendorConfirm" (click)="sendToVendorSelecteArticleConfirm()" style="display:none">Add</button>
      <button type="button" id="btnMultipleSendtoVendor" (click)="sendToVendorSelecteArticle()" style="display:none">Add</button>

      <button type="button" id="btnMultipleExcel" (click)="ManuallAllocationUploadExcel()" style="display:none">Add</button>
      <input type="file" #file id="FilePackage" placeholder="Choose file" (change)="UploadPackage(file.files)" style="display:none;">

      <button type="button" id="btnAutoNTAllocation" (click)="AutoAllocationNT()" style="display:none">Allocate</button>

      <button type="button" id="btnAutoNTAllocationConfim" (click)="AutoAllocationNTConfim()" style="display:none">Allocate</button>

      <div class="divContainer" style="top:-10px;">

        <ul class="nav nav-tabs nav-tabs-custom" id="TabulAllocation">
          <li class="nav-item">
            <a data-toggle="tab" href="#ConversionList" name="Conversion" class="nav-link active"
               (click)="GetManualAllocationList('Conversion')">Conversion</a>
          </li>
          <li class="nav-item">
            <a data-toggle="tab" href="#ImageProcessList" name="ImageProcess" class="nav-link"
               (click)="GetManualAllocationList('ImageProcess')">Image Process</a>
          </li>
        </ul>

        <div class="col-sm-12" id="divMainFilter">
          <div class="row">
            <div class="col-sm-3">
              <label>Batch #</label>
              <select id="lstBatch" class="form-control" multiple onchange="$('#btnGetBatch').trigger('click');">
                <option *ngFor="let item of lstBatchList" value={{item.Volume}}>
                  {{item.Volume}}
                </option>
              </select>
            </div>

            <div class="col-sm-3 divHide">
              <label>Article</label>
              <select id="lstArticle" class="form-control select2" multiple>
                <!--<option value="All" selected="selected">All</option>-->
                <option *ngFor="let item of lArticleList" value={{item.ArticleID}}>
                  {{item.ArticleNo}}
                </option>
              </select>
            </div>

            <div class="col-sm-2">
              <label>Load Type</label>
              <select id="ddlFilterType" class="form-control">
                <option value="All">All</option>
                <option value="Allocated">Allocated</option>
                <option selected value="UnAllocated">UnAllocated</option>
                <option value="Vendor">Vendor</option>
              </select>
            </div>

            <div class="col-sm-3">
              <div class="row col">
                <div class="col-6">
                  <label>From</label>
                  <input type="date" name="FromDate" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
                </div>
                <div class="col-6">
                  <label>To</label>
                  <input type="date" name="ToDate" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <button type="button" class="btn btn-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>

          </div>

        </div>
      </div>
      <br />
      <div id="divDataList" style="position: relative;">
        <input type="hidden" name="rowIndex" id="rowIndex" value="0">

        <table id="tblVendorNTManualart" #dataTable class="display" style="width:100%;"></table>
      </div>

      <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
        <div class="modal-dialog modal-xl-g">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Allocate</h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
            </div>

            <div class="modal-body">

              <div class="row" id="divSelect">
                <div class="col-12">
                  <div class="form-group">
                    <label>User:</label><em>*</em>
                    <select id="ddluser" name="RoleID" class="form-control select2" required onchange="$('#btnDropChangeAll').trigger('click');">
                      <option value="0">Select</option>
                      <option *ngFor="let item of userList" value={{item.UserID}}>{{item.LoginName}}</option>
                    </select>

                  </div>


                  <div class="form-group">
                    <label>Allocate Date</label>
                    <input type="date" id="TxtAllocateDate" class="form-control float-right" autocomplete="off" />
                  </div>

                </div>

              </div>
              <br />
              <div class="row">
                <div class="col-3">
                  <div class="form-group">
                    <label>Capacity</label>
                    <input type="text" class="form-control" name="FirstName" id="txtCapacity" placeholder="" required maxlength="20" disabled>
                  </div>

                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Alloted</label>
                    <input type="text" class="form-control" name="FirstName" id="txtAllocated" placeholder="" required maxlength="20" disabled>
                  </div>

                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Unalloted</label>
                    <input type="text" class="form-control" name="FirstName" id="txtUnAllocated" placeholder="" required maxlength="20" disabled>
                  </div>

                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label>Available</label>
                    <input type="text" class="form-control" name="FirstName" id="txtAvailable" placeholder="" required maxlength="20" disabled>
                  </div>

                </div>


              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              <button type="submit" (click)="AllocateMultiple()" class="btn btn-success waves-effect waves-light" value="Update">Allocate</button>
            </div>

            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>
